<script setup lang="ts">
import type {VariantProps} from 'class-variance-authority'
import {toggleVariants} from '@/components/ui/toggle'
import {cn} from '@/lib/utils'
import {
  ToggleGroupItem,
  type ToggleGroupItemProps,
  useForwardProps
} from 'radix-vue'
import {computed, type HTMLAttributes, inject} from 'vue'

type ToggleGroupVariants = VariantProps<typeof toggleVariants>

const props = defineProps<ToggleGroupItemProps & {
  class?: HTMLAttributes['class']
  variant?: ToggleGroupVariants['variant']
  size?: ToggleGroupVariants['size']
}>()

const context = inject<ToggleGroupVariants>('toggleGroup')

const delegatedProps = computed(() => {
  const {class: _, variant, size, ...delegated} = props
  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <ToggleGroupItem
      v-bind="forwardedProps" :class="cn(toggleVariants({
      variant: context?.variant || variant,
      size: context?.size || size,
    }), 'flex h-8 w-full items-center justify-center rounded-2xl border border-input bg-background px-3 py-2 text-sm ring-offset-background data-[placeholder]:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-ring focus:ring-offset-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate', props.class)"
  >
    <slot/>
  </ToggleGroupItem>
</template>
